import type { GetCityListInputType, GetTicketsInputType, ITicketPickerFacade } from '../types/facades/ITicketPickerFacade';
import type { CardSupport } from '../types/models/CardSupport';
import type { City } from '../types/models/City';
import type { FareProfile } from '../types/models/FareProfile';
import type { Tickets } from '../types/models/Tickets';
import type { TransportMode } from '../types/models/TransportMode';
import type { ITransportTicketPickerClient } from '../types/services/ITransportTicketPickerClient';

export class TicketPickerFacade implements ITicketPickerFacade {
    private _apiClient;

    constructor(apiClient: ITransportTicketPickerClient) {
        this._apiClient = apiClient;
    }

    public async getCityList(params: GetCityListInputType): Promise<Array<City>> {
        return await this._apiClient.getCityList(params);
    }

    public async getTransportModeList(): Promise<Array<TransportMode>> {
        return await this._apiClient.getTransportModeList();
    }

    public async getFareProfileList(): Promise<Array<FareProfile>> {
        return await this._apiClient.getFareProfileList();
    }

    public async getTickets(params: GetTicketsInputType): Promise<Tickets> {
        return await this._apiClient.getTickets(params);
    }

    public async getCardSupportList(): Promise<Array<CardSupport>> {
        return await this._apiClient.getCardSupportList();
    }
}
